import { StateCodeEnum, StateEnum } from '../types/address';

const STATES: {
  [state: string]: string
} = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  'District of Columbia': 'DC',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
  Alberta: 'AB',
  'British Columbia': 'BC',
  Manitoba: 'MB',
  'New Brunswick': 'NB',
  Newfoundland: 'NF',
  'Northwest Territory': 'NT',
  'Nova Scotia': 'NS',
  Nunavut: 'NU',
  Ontario: 'ON',
  'Prince Edward Island': 'PE',
  Quebec: 'QC',
  Saskatchewan: 'SK',
  Yukon: 'YT',
};

export const getStateCodeFromStateName = (
  stateName: string | StateEnum,
) => STATES[stateName] || stateName;

export const getStateNameFromStateCode = (stateCode: string | StateCodeEnum) => {
  const stateName = Object.keys(STATES).find((key) => STATES[key] === stateCode);
  return stateName || stateCode;
};

export const getFormattedStreetAddress = (place: any) : string => {
  if (!place || !place.address_components) {
    return '';
  }
  let formattedStreetAddress = `${place.address_components.find((component: any) => component.types.includes('street_number'))?.long_name} ${place.address_components.find((component: any) => component.types.includes('route'))?.long_name}`;
  if (place.address_components.find((component: any) => component.types.includes('subpremise'))) {
    formattedStreetAddress += ` ${place.address_components.find((component: any) => component.types.includes('subpremise'))?.long_name}`;
  }
  return formattedStreetAddress;
};
